import { _decorateTitle } from "../shared/utils"
import _get from 'lodash/get'

/**
 * Prepare Breadcrumb list for SEO
 * @param urlItem
 * @param item
 * @param baseUrl
 */
export function getBreadcrumbList (item, urlItem, baseUrl) {
  const itemListElement = []
  if (Array.isArray(item)){
    item.forEach(el => {
      itemListElement.push({
        '@type': 'ListItem',
        position: itemListElement.length + 1,
        name: el.name,
        item: el.linkUrl
      })
    });
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement
    }
  }
  // Home
  itemListElement.push({
    '@type': 'ListItem',
    position: itemListElement.length + 1,
    name: 'Home',
    item: baseUrl
  })

  // Category
  if (item.principalCategory) {
    const categoryTitle = _get(item, 'principalCategory.name', _get(item, 'principalCategory.title', 'Catégorie'))

    itemListElement.push({
      '@type': 'ListItem',
      position: itemListElement.length + 1,
      name: categoryTitle,
      item: `${baseUrl}/categorie/${item.principalCategory.id}/${_decorateTitle(categoryTitle)}`
    })
  }

  // Item
  itemListElement.push({
    '@type': 'ListItem',
    position: itemListElement.length + 1,
    name: _get(item, 'title', 'Film'),
    item: `${baseUrl}${urlItem}`
  })

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement
  }
}
